import styled from 'styled-components';

export const WrapperLoading = styled.div`
  width: 50rem;
  height: 14rem;
`;
